import { PropsWithChildren } from 'react';
import { YMInitializer } from 'react-yandex-metrika';
import { YANDEX_METRIKA_ENABLED, YANDEX_METRIKA_ID } from 'shared/config';
import { createComposableProvider } from 'shared/lib';

const YandexMetrikaProvider = ({ children }: PropsWithChildren) => (
	<>
		{YANDEX_METRIKA_ENABLED && (
			<YMInitializer
				accounts={[YANDEX_METRIKA_ID]}
				version='2'
				options={{
					webvisor: true,
					clickmap: true,
					ecommerce: 'dataLayer',
					accurateTrackBounce: true,
					trackLinks: true,
				}}
			/>
		)}
		{children}
	</>
);

export const withYandexMetrika = createComposableProvider(YandexMetrikaProvider);
